import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders }    from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IAuditData } from '../audit-trail/audit-data';

@Injectable()
export class AuditService {
  private  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  getData(): Observable<IAuditData> {
    const URL = `${this.baseUrl}/api/audit/loadAuditTrail`;
    //const URL = 'https://jsonplaceholder.typicode.com/todos';
    return this.http.get<IAuditData>(URL);
  }

}